import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

import type { PPTChartElement } from '@/types/slides'
import type { ContextmenuItem } from '@/components/Contextmenu/types'
import emitter, { EmitterEvents } from '@/utils/emitter'

import ElementOutline from '@/views/components/element/ElementOutline.vue'
import Chart from './Chart.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    elementInfo: {},
    selectElement: { type: Function },
    contextmenus: { type: Function }
  },
  setup(__props: any) {

const props = __props

const handleSelectElement = (e: MouseEvent | TouchEvent) => {
  if (props.elementInfo.lock) return
  e.stopPropagation()

  props.selectElement(e, props.elementInfo)
}

const openDataEditor = () => {
  emitter.emit(EmitterEvents.OPEN_CHART_DATA_EDITOR)
}

return (_ctx: any,_cache: any) => {
  const _directive_contextmenu = _resolveDirective("contextmenu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["editable-element-chart", { 'lock': _ctx.elementInfo.lock }]),
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${_ctx.elementInfo.rotate}deg)` })
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "element-content",
        style: _normalizeStyle({
          backgroundColor: _ctx.elementInfo.fill,
        }),
        onMousedown: _cache[0] || (_cache[0] = $event => handleSelectElement($event)),
        onTouchstart: _cache[1] || (_cache[1] = $event => handleSelectElement($event)),
        onDblclick: _cache[2] || (_cache[2] = ($event: any) => (openDataEditor()))
      }, [
        _createVNode(ElementOutline, {
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height,
          outline: _ctx.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createVNode(Chart, {
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height,
          type: _ctx.elementInfo.chartType,
          data: _ctx.elementInfo.data,
          options: _ctx.elementInfo.options,
          themeColor: _ctx.elementInfo.themeColor,
          gridColor: _ctx.elementInfo.gridColor,
          legends: _ctx.elementInfo.data.legends,
          legend: _ctx.elementInfo.legend || ''
        }, null, 8, ["width", "height", "type", "data", "options", "themeColor", "gridColor", "legends", "legend"])
      ], 36)), [
        [_directive_contextmenu, _ctx.contextmenus]
      ])
    ], 4)
  ], 6))
}
}

})